import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  get currentUser() {
    const data = localStorage.getItem('currentUser');
    return data ? JSON.parse(data) : null;
  }

  get token(): string | null {
    return this.currentUser?.token || null;
  }

  get userId(): number | null {
    return this.currentUser?.userId || null;
  }

  get name(): string | null {
    return this.currentUser?.name || null;
  }

  clear() {
    localStorage.removeItem('currentUser');
  }
}
